import setup from 'ln/setup/setup';
import { backend } from '../../setup';
import { ISlide } from '../slideview/SlideDetailView';
import SequenceBase from './SequenceBase';
import moment from 'moment';

interface IFeedbackSlide extends ISlide{
	model: FeedbackSequenceModel
}

class FeedbackSequenceModel extends SequenceBase {

	private slides:IFeedbackSlide[];

	constructor( json:Object ){
		super( json );

		this.slides = [{
			id: 'feedback-sequence',
			modelName: this.modelName,
			layout: 'feedback',
			template: 'slide-feedbacksequence',
			courseversion: '',
			startdate: '',
			title: this.title,
			pagenumber: '',
			model: this
			
		}];
	}

	get feedbackUrl():string {
		let url = new URL(setup.data( 'feedback_sequence.url'));

		let date = moment( this.course.firstDaybreak.date, 'YYYY-MM-DD' );
		let time = this.course.firstDaybreak.time.split(':');
		date.hours( parseInt( time[0] ) );
		date.minute( time[1] ? parseInt( time[1] ) : 0);



		if( this.course ){
			let params = new URLSearchParams();
			params.append('id', this.course.id);
			params.append('title',this.course.title);
			params.append('location', this.course.location);
			params.append('date', date.format() ); // https://momentjs.com/docs/#/displaying/format/
			params.append('owner', this.course.owner.username);
			params.append('owner-email', this.course.owner.email);
			params.append('guestusers', this.course.guestusers.all().map( guestuser => guestuser.username ).join(','));
			params.append('customer', this.course.customer);
			params.append('lang',setup.data('current_lang'));

			let paramsBase64Encode = btoa(params.toString());

			url.searchParams.append('data', paramsBase64Encode);
		}
		return url.toString();
	}

	get qrCodeUrl():string {
		// Documentation found on https://goqr.me/api/
		return "https://api.qrserver.com/v1/create-qr-code/?data=" + encodeURIComponent( this.feedbackUrl ) + "&size=220x220&margin=12";
	}
	
}

export default FeedbackSequenceModel;


backend.mapper.toJson.add( 'App\\FeedbackSequence', function( model:FeedbackSequenceModel ) {
	return { modelName: model.modelName };
});